// ----------------------------------------------------------------------
// <copyright file="Izenda.ConditionalFormattingCondition.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------


import { observable } from 'mobx';
import constants from 'logic/data/Izenda.ConditionalFormattingConstants';

const {CONDITION_TYPE} = constants;

class ConditionRangeValue {
  @observable from;
  @observable to; 
}

export default class ConditionalFormattingCondition{
  @observable conditionField = {
    name: '',
    type: '',
    dateTimeFormatData: '',
    containerType: ''
  };
  @observable type = null;
  @observable value = null;
  
  additionalConditions = [];

  constructor(condition){
    if(condition){
      this.parseData(condition);
    }
  } 

  setField(field){
    const {previewDataType, dateTimeFormatData, containerType} = field.additionalValue;
    this.conditionField = {
      name: field.value,
      type: previewDataType,
      dateTimeFormatData: dateTimeFormatData,
      containerType: containerType
    };
    this.type = null;
    this.value = null;
    this.additionalConditions = [];
  }

  setType(type){
    this.type = type;
    if(type === CONDITION_TYPE.RANGE_VALUE.value
      || type === CONDITION_TYPE.RANGE_PERCENT.value){
      this.value = new ConditionRangeValue();
    }else{
      this.value = null;
    }
  }

  setValue(value){
    const condition = this;
    if(condition.type === CONDITION_TYPE.RANGE_VALUE.value
      || condition.type === CONDITION_TYPE.RANGE_PERCENT.value){
      this.value = new ConditionRangeValue();
      this.value.from = value.from;
      this.value.to = value.to;
    }else{
      this.value = value;
    }  
  }

  parseData(condition){
    this.conditionField = condition.conditionField;
    this.type = condition.type;
    this.additionalConditions = condition.additionalConditions || [];

    if(condition.type === CONDITION_TYPE.RANGE_VALUE.value
      || condition.type === CONDITION_TYPE.RANGE_PERCENT.value){
      this.value = new ConditionRangeValue();
      this.value.from = condition.value.from;
      this.value.to = condition.value.to;
    }else{
      this.value = condition.value;
    }    
  }

  serializeData(){
    const {conditionField, type, value, additionalConditions }  = this;
    return {
      conditionField,
      type,
      value,
      additionalConditions
    };
  }
}


// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ConditionalFormatting/Izenda.ConditionalFormattingCondition.js